export { SORT_TYPES } from './sortTypes';

export const EVENTS_ATTENDANCE_COLUMNS = [
  { id: 'event_date', label: 'Event Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'event_name', label: 'Event', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'capacity', label: 'Capacity', alwaysVisible: false, defaultVisible: false, sortable: false, sortType: 'number' },
  { id: 'tickets_sold', label: 'Tickets Sold', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'checked_in', label: 'Checked In', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'attendance_rate', label: 'Attendance Rate', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'no_shows', label: 'No Shows', alwaysVisible: false, defaultVisible: false, sortable: false, sortType: 'number' },
  { id: 'comp_tickets', label: 'Comp Tickets', alwaysVisible: false, defaultVisible: false, sortable: false, sortType: 'number' },
  { id: 'paid_tickets', label: 'Paid Tickets', alwaysVisible: false, defaultVisible: false, sortable: false, sortType: 'number' },
];

export const getDefaultVisibleColumns = () =>
  EVENTS_ATTENDANCE_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  EVENTS_ATTENDANCE_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
